import { addDays, format as fnsFormat, isFuture, isPast } from 'date-fns'
import IBAN from 'iban'
import * as Yup from 'yup'

// import { AnyObject, Maybe } from 'yup/lib/types';
import { validateIban } from '../api/iban/iban-service'

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'formatOfDate',
  function formatOfDate(formats, message) {
    // need to be string for custom error message
    return this.test('testFormat', message, function testFormat(value) {
      if (value) {
        return value === fnsFormat(new Date(value), formats)
      }
      return true
    })
  }
)
Yup.addMethod(Yup.string, 'elderAge', function elderAge(years, message) {
  // need to be string for custom error message
  return this.test('testAge', message, function testAge(value) {
    if (value) {
      let diff = Math.abs(new Date(value).getFullYear() - new Date().getFullYear())
      return diff < years
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'fullAge', function fullAge(years, message) {
  // need to be string for custom error message
  return this.test('testAge', message, function testAge(value) {
    if (value) {
      let diff = Math.abs(new Date(value).getFullYear() - new Date().getFullYear())
      return diff >= years
    }
    return true
  })
})
Yup.addMethod<Yup.StringSchema>(Yup.string, 'notInFuture', function notInFuture(message) {
  // need to be string for custom error message
  return this.test('testAge', message, function testAge(value) {
    if (value) {
      return !isFuture(new Date(value))
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'notInPast', function notInPast(message) {
  // need to be string for custom error message
  return this.test('testDateNotInPast', message, function testDateNotInPast(value) {
    if (value) {
      const date = addDays(new Date(value), 1)
      return !isPast(date)
    }
    return true
  })
})

Yup.addMethod(Yup.string, 'notInNearFuture', function notInNearFuture(addedDays, message) {
  // need to be string for custom error message
  return this.test('testDateNotInNearFuture', message, function testDateNotInNearFuture(value) {
    if (value) {
      const dateform = new Date(value)
      const minDate = addDays(new Date(), addedDays)
      return dateform > minDate
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'notInFarFuture', function notInFarFuture(addedDays, message) {
  // need to be string for custom error message
  return this.test('testDateNotInFarFuture', message, function testDateNotInFarFuture(value) {
    if (value) {
      const dateform = new Date(value)
      const maxDate = addDays(new Date(), addedDays)
      return dateform < maxDate
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'minValue', function minValue(message, minValueParam) {
  return this.test('testMin', message, function testMin(value) {
    if (!value) {
      return true
    }
    return parseFloat(value.replace(/,/g, '.')) >= minValueParam
  })
})
Yup.addMethod(Yup.string, 'maxValue', function maxValue(message, maxValueParam) {
  return this.test('testMax', message, function testMax(value) {
    if (!value) {
      return true
    }
    return parseFloat(value.replace(/,/g, '.')) <= maxValueParam
  })
})
Yup.addMethod(Yup.string, 'atLeastOneOf', function atLeastOneOf(list, message) {
  return this.test('testAtLeastOneOf', message, function testAtLeastOneOf(value) {
    if (value && list && Array.isArray(list)) {
      return list.some((item) => this.parent[item] !== undefined)
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'VATNumberValidation', function ValidateAFM(message) {
  // need to be string for custom error message
  return this.test('VATNumberValidation', message, function VATNumberValidation(value) {
    if (value) {
      let sum = 0
      let p = 8
      if (value.length !== 9 || parseInt(value, 10) < 0) {
        return false
      } else {
        for (let index = 0; index <= value.length - 2; index++) {
          sum += parseInt(value.charAt(index), 10) * Math.pow(2, p)
          p = p - 1
        }
      }
      if (sum % 11 === parseInt(value.charAt(8), 10) || parseInt(value.charAt(8), 10) === 0) {
        return true
      } else {
        return false
      }
    }
    return true
  })
})
Yup.addMethod(Yup.string, 'iBANService', function iBANService(message) {
  return this.test('iBANService', message, function service(value) {
    if (value !== undefined && IBAN.isValid(value)) {
      return validateIban(value.replace(/[\W_]+/g, '')).then((response) => {
        const r = response as { data?: { isValid?: boolean } }
        return Boolean(r.data && r.data.isValid)
      })
    }
    return false
  })
})

declare module 'yup' {
  // interface StringSchema<
  //   TType extends Maybe<string> = string | undefined,
  //   TContext extends AnyObject = AnyObject,
  //   TOut extends TType = TType
  // > extends Yup.BaseSchema<TType, TContext, TOut> {
  //   formatOfDate(formats, message): StringSchema<TType, TContext>;
  //   fullAge(value, message): StringSchema<TType, TContext>;
  //   elderAge(value, message): StringSchema<TType, TContext>;
  //   notInFuture(message): StringSchema<TType, TContext>;
  //   VATNumberValidation(message): StringSchema<TType, TContext>;
  //   iBANService(message): StringSchema<TType, TContext>;
  // }
  interface StringSchema {
    formatOfDate(formats, message): this
    fullAge(value, message): this
    elderAge(value, message): this
    notInFuture(message): this
    VATNumberValidation(message): this
    iBANService(message): this
  }
}

function getYearDiff(date1, date2) {
  return Math.abs(date2.getFullYear() - date1.getFullYear())
}

export default Yup
